import type { ExecutionResult } from 'graphql';

import { getApiToken } from '@/auth/utils/cognitoSession';
import config from '@/config';
import { bearerAuth } from '@/core/api';
import NotFoundPage from '@/pages/NotFoundPage';

import { LegacyRoute } from '../routesMiddleware';

interface GraphQLParams {
  query: string;
  operationName?: string | null;
  variables?: Record<string, unknown> | null;
}

async function graphQLFetcher(graphQLParams: GraphQLParams): Promise<ExecutionResult> {
  // ENG-6102: per request, so a refreshed Cognito ID token is picked up.
  const token = await getApiToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: bearerAuth(token) }),
  };

  const response = await fetch(`${config.apiUrl}/graphql`, {
    method: 'post',
    headers,
    body: JSON.stringify(graphQLParams),
  });
  return (await response.json()) as ExecutionResult;
}

const route: LegacyRoute = {
  path: '/graphiql',

  async action({ store }) {
    const { viewer } = store.getState();
    if (import.meta.env.MODE !== 'development' && !viewer.id) return <NotFoundPage />;

    const GraphIQL = (await import('graphiql')).default;
    document.title = 'GraphiQL';
    return (
      <div style={{ height: '100vh' }}>
        <GraphIQL fetcher={graphQLFetcher} />
      </div>
    );
  },
};

export default route;
